/** Preserve four reference positions; corrupt entries never move valid neighbors. */
export function normalizeShortcutSlots(raw){
 return Array.from({length:4},(_,i)=>{
  const value=Array.isArray(raw)?raw[i]:null;
  return value&&typeof value==='object'&&['skill','item'].includes(value.kind)&&typeof value.id==='string'&&value.id.length<=80&&/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value.id)?{kind:value.kind,id:value.id}:null;
 });
}
